module.exports = __webpack_public_path__ + "static/img/card_feature_smart_rescue.4ce9add.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GlobalRescue/card_feature_smart_rescue.png
// module id = 2lxK
// module chunks = 1